import gql from 'graphql-tag';

export const collaboratingUserLeftSurfaceSubscription = gql`
  subscription collaboratingUserLeftSurface($surface: ID!, $user: ID!) {
    collaboratingUserLeftSurfaceSubscription(surface: $surface, user: $user) {
      user {
        id
        email
        fullName
      }
      cursorPosition {
        x
        y
      }
      surface
    }
  }
`;
